import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import {
  myOrders_list_action,
  order_delete_action,
  blocked_till_action,
  get_follow_up_action,
  order_cancel_reason_action,
  download_performa_invoice_action,
} from "../../../actions/myOrders_action/myOrders_action";
import { fill_action } from "../../../actions/fillList_action";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Nav } from "react-bootstrap";
import Loader from "../../../utils/Loader";
import {
  TypeOfEventActionId,
  cancellationReasonActionId,
  downloadReport,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../../utils/constants";
import Header from "../../../common_components/Header";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Pagination from "../../../utils/pagination";
const CustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    />
  )
);
const followUpStyle = `
.custom_dropdow .dropdown-content.followUp_Dropdown {
  display: none;
  position: absolute;
  left: 5px;
  background-color: #f1f1f1;
  min-width: 100px;
  box-shadow: 0px 0px 4px 3px rgba(0,0,0,0.2);
  z-index: 1;
}
.custom_dropdow .dropdown-content label.followUp {
    color: black;
    padding: 2px 10px;
    text-decoration: none;
    display: block;
    font-size: 13px;
}
`;
class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: "desc", // Initial sort order
      sortedColumn: "OrderID",
      isLoading: false,
      isAccordionExpanded: false,
      show: false,
      deleteShow: false,
      editShow: false,
      PiShow: false,
      is_release: false,
      isModifyEdit: false,
      isEdit: 1,
      userId: "",
      OrderID: "",
      CenterID: "",
      RoleID: "",
      ClientID: "",
      Date: "",
      StatusID: "",
      OrderDate: "",
      ItmeCenter: "",
      TypeOfEventID: "",
      TypeOfEvent: "",
      EventName: "",
      CompanyName: "",
      BookingDate: "",
      PrimaryEmailID: "",
      BlockedDate: "",
      ReceivedDate: "",
      OrderAmount: "",
      ConvenienceFee: "",
      RefundAmount: "",
      currentPage: 1,
      CancellationReasonID: "",
      cancelNote: "",
      AdminRemark: "",
      cancellationReasonList: [],
      MyOrdersData: [],
      proformaList: [],
      filteredData: [],
      eventFillList: [],
      followUpList: [],
      AdditionalServiceStatus: "",
      //calculated deduction
      deduction: "",
      finalAmount: "",
      //dateRange
      dateRange: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
      FromDate: "",
      ToDate: "",
    };
    this.updateItem = this.updateItem.bind(this);
    this.onEditNavigate = this.onEditNavigate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.downloadPerformaInvoice = this.downloadPerformaInvoice.bind(this);
    this.handleBlockedTill = this.handleBlockedTill.bind(this);
    this.onPreviewNavigate = this.onPreviewNavigate.bind(this);
  }
  async componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    sessionStorage.removeItem("formFile");
    sessionStorage.removeItem("membershipFormFileType");
    sessionStorage.removeItem("fileName");
    sessionStorage.removeItem("checkboxFlag");
    sessionStorage.removeItem("dummyMembershipFlag");
    sessionStorage.removeItem('newbookArray')
    sessionStorage.removeItem('bookArray')

    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      FormData: localStorage.getItem("FromDate"),
      ToDate: localStorage.getItem("ToDate"),
    });
    try {
      await this.myOrdersList();
      this.getFillList(TypeOfEventActionId, userId, "", "");
      this.getFillList(cancellationReasonActionId, userId, "", "");
      this.getFollowUpNote();
    } catch (error) {
      console.error(error);
    }
  }
  async getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    try {
      const data = await this.props.fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      );
      console.log(data, "eventFillList");
      if (data.error != 1 && value == TypeOfEventActionId) {
        this.setState({ eventFillList: data.data, isLoading: false });
      }
      if (value == cancellationReasonActionId) {
        this.setState({ cancellationReasonList: data.data, isLoading: false });
        console.log("cancellationReasonActionId", data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }
  handleSort = (columnName) => {
    const { MyOrdersData, sortOrder, sortedColumn } = this.state;
    let newSortOrder = sortOrder;
    if (columnName === sortedColumn) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    const sortedData = MyOrdersData.slice().sort((a, b) => {
      if (newSortOrder === "asc") {
        return a[columnName] - b[columnName];
      } else {
        return b[columnName] - a[columnName];
      }
    });
    this.setState({
      MyOrdersData: sortedData,
      sortOrder: newSortOrder,
      sortedColumn: columnName,
    });
  };

  getFollowUpNote = async () => {
    const { userId, OrderID, followUpList } = this.state;
    this.setState({ isLoading: true });
    this.props
      .get_follow_up_action(userId, OrderID)
      .then((data) => {
        console.log(data, "from UI FollowUp");
        if (data.error !== 1) {
          this.setState({
            followUpList: data.data,
            isLoading: false,
            currentPage: 1,
          });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  chooseDate(item) {
    this.setState({ dateRange: [item.selection] });
    this.setState({
      FromDate:
        item.selection["startDate"] != null ? (
          moment(item.selection["startDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
      ToDate:
        item.selection["endDate"] != null ? (
          moment(item.selection["endDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
    });
  }

  deleteModalShow(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    RoleID,
    OrderAmount,
    BookingDate,
    CancellationReasonID,
    cancelNote,
    AdminRemark,
    DeliveryStatus
  ) {
    const { ConvenienceFee, RefundAmount } = this.state;
    this.setState({
      deleteShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      CompanyName: CompanyName,
      PrimaryEmailID: PrimaryEmailID,
      RoleID: RoleID,
      OrderAmount: OrderAmount,
      BookingDate: BookingDate,
      CancellationReasonID: CancellationReasonID,
      cancelNote: cancelNote,
      AdminRemark: AdminRemark,
      DeliveryStatus: DeliveryStatus,
    });
    // Check if BookingDate is null or empty
    if (!BookingDate || BookingDate.trim() === "") {
      BookingDate = null; // Set BookingDate to null if it's empty
    } else {
      // Split the BookingDate string into an array of individual date strings
      const dateStrings = BookingDate.split(",");

      // Parse the date strings and find the most recent date
      let mostRecentDate = null;
      for (const dateString of dateStrings) {
        const [day, month, year] = dateString.trim().split("/");
        const bookingDate = new Date(`${year}-${month}-${day}`);
        if (!mostRecentDate || bookingDate > mostRecentDate) {
          mostRecentDate = bookingDate;
        }
      }

      // Calculate deduction and finalAmount based on the most recent date
      let deduction = 0;
      let finalAmount = OrderAmount;
      const today = new Date();
      const timeDifference = mostRecentDate - today;
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

      if (daysDifference > 15) {
        deduction = 0; // No deduction
      } else if (daysDifference <= 15 && daysDifference > 10) {
        deduction = OrderAmount * 0.25;
        finalAmount -= deduction;
      } else if (daysDifference <= 10 && daysDifference > 5) {
        deduction = OrderAmount * 0.75;
        finalAmount -= deduction;
      } else {
        deduction = OrderAmount;
        finalAmount = 0;
      }

      this.setState({
        BookingDate: mostRecentDate, // Set BookingDate to the most recent date
        ConvenienceFee: deduction.toLocaleString("en-IN"), // Set ConvenienceFee to deduction
        RefundAmount: finalAmount.toLocaleString("en-IN"), // Set RefundAmount to finalAmount
      });
    }

    console.log(
      "deleteModal",
      OrderID,
      OrderNo,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount,
      BookingDate,
      CancellationReasonID,
      cancelNote,
      "conv",
      ConvenienceFee,
      RefundAmount,
      DeliveryStatus
    );
  }

  deleteModalClose() {
    this.setState({ deleteShow: false });
  }
  editModalShow(
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit,
    ClientID
  ) {
    console.log(StatusID, ClientID, "ClientID");
    this.setState({
      editShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      StatusID: StatusID,
      CenterID: CenterID,
      BookingDate: BookingDate,
      isEdit: isEdit,
      ClientID: ClientID,
    });
  }
  editModalClose() {
    this.setState({ editShow: false, isModifyEdit: false });
  }
  piModalShow(
    OrderID,
    OrderNo,
    ProformaInvoiceID,
    ProformaInvoice_No,
    ProformaType
  ) {
    // Splitting comma-separated values
    const idList = ProformaInvoiceID.split(",").map(Number);
    const noList = ProformaInvoice_No.split(",").map(String);
    const typeList = ProformaType.split(",").map(String);

    // Extracting Proforma details
    const proformaDetails = idList.map((id, index) => ({
      ProformaInvoiceID: id,
      ProformaInvoice_No: noList[index],
      ProformaType: typeList[index],
    }));

    console.log(OrderID, OrderNo, proformaDetails);

    this.setState({
      PiShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      proformaList: proformaDetails,
    });
  }
  piModalClose() {
    this.setState({ PiShow: false });
  }
  modalShow = (
    BlockedDate,
    OrderID,
    BookingDate,
    ItmeCenter,
    PrimaryEmailID
  ) => {
    const parsedBlockedDate = new Date(BlockedDate);
    if (!isNaN(parsedBlockedDate.getTime())) {
      this.setState({
        show: true,
        BlockedDate: parsedBlockedDate,
        OrderID: OrderID,
        BookingDate: BookingDate,
        ItmeCenter: ItmeCenter,
        PrimaryEmailID: PrimaryEmailID,
      });
      console.log(
        "BlockedDate",
        BlockedDate,
        OrderID,
        BookingDate,
        ItmeCenter,
        PrimaryEmailID
      );
    } else {
      console.log("Invalid date format:", BlockedDate);
    }
  };
  modalClose = () => {
    this.setState({ show: false });
  };
  isFollowShow(DeliveryStatus) {
    if (DeliveryStatus === "Incomplete") {
      return true;
    }
    return false;
  }
  isProformaShow(StatusID, Is_proforma, DeliveryStatus) {
    if (Is_proforma === false) {
      if (
        DeliveryStatus === "Confirmed" ||
        (DeliveryStatus === "Incomplete" && StatusID === 10)
      ) {
        return true;
      }
    }
    return false;
  }
  onPreviewNavigate(
    OrderID,
    OrderNo,
    ClientID,
    DeliveryStatus,
    ProformaInvoiceID,
    ProformaInvoice_No,
    CompanyName,
    PrimaryEmailID,
    CenterID
  ) {
    this.props.navigate("/ordersEdit", {
      state: {
        OrderID: OrderID,
        OrderNo: OrderNo,
        ClientID: ClientID,
        DeliveryStatus: DeliveryStatus,
        ProformaInvoiceID: ProformaInvoiceID,
        ProformaInvoice_No: ProformaInvoice_No,
        CompanyName: CompanyName,
        PrimaryEmailID: PrimaryEmailID,
        CenterID: CenterID,
      },
    });
  }

  isBlockTillShow(DeliveryStatus) {
    if (DeliveryStatus === "Approved") {
      return true;
    }
    return false;
  }
  isEditShow(DeliveryStatus) {
    if (
      DeliveryStatus === "Incomplete" ||
      DeliveryStatus === "Confirmed" ||
      DeliveryStatus === "Pending for Verification" ||
      DeliveryStatus === "Approved"
    ) {
      return true;
    }
    return false;
  }
  isFeedbackRedirect(DeliveryStatus) {
    if (DeliveryStatus === "Delivered") {
      return true;
    }
    return false;
  }
  isDeleteShow(DeliveryStatus) {
    if (
      DeliveryStatus === "Incomplete" ||
      DeliveryStatus === "Confirmed" ||
      DeliveryStatus === "Pending for Verification" ||
      DeliveryStatus === "Cancellation Request"
    ) {
      return true;
    }
    return false;
  }
  onFeedbackNavigate = (OrderID) => {
    this.props.navigate("/feedback", {
      state: {
        OrderID: OrderID,
        Is_view: true,
      },
    });
  };
  AgreeModification = (OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit = 1,
    ClientID, navAction) => {
    if (StatusID == 11 || StatusID == 12 || StatusID == 16 || StatusID == 17) {
      this.setState({ isModifyEdit: true })
    } else {
      if (StatusID === 1 || StatusID === 2 || StatusID === 3 || StatusID === 4) {
        this.props.navigate("");
      } else if (StatusID === 5) {
        this.props.navigate("/companyInfo", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 6) {
        this.props.navigate("/BookingDetails", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 7) {
        this.props.navigate("/additionalServices", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 8) {
        this.props.navigate("/termsAndConditons", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 9) {
        this.props.navigate("/summary", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 10 || StatusID === 13) {
        this.props.navigate("/cart", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else {
        this.props.navigate("");
      }
    }
  }
  onEditNavigate = (
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit = 1,
    ClientID, navAction
  ) => {
    if (StatusID === 11 || StatusID === 12 || StatusID === 16 || StatusID === 17) {
      sessionStorage.removeItem("navAgain");
      sessionStorage.setItem("Is_modify", true);
      sessionStorage.setItem("OrderID", OrderID);
      sessionStorage.setItem("OrderNo", OrderNo);
      sessionStorage.setItem("centerID", CenterID);
      sessionStorage.setItem("ClientID", ClientID);
      sessionStorage.removeItem("bookArray");
      sessionStorage.removeItem("validationDateList");
      this.props.navigate(navAction == 1 ? "/calenderView" : navAction == 2 ? "/companyInfo" : navAction == 3 ? "/BookingDetails" : navAction == 4 ? "/additionalServices" : navAction == 5 ? "/termsAndConditons" : navAction == 6 ? "/summary" : "", {
        state: {
          OrderID: OrderID,
          OrderNo: OrderNo,
          StatusID: StatusID,
          CenterID: CenterID,
          BookingDate: BookingDate,
          isEdit: isEdit,
          ClientID: ClientID,
        },
      });
    }
  };
  myOrdersList = async () => {
    const { OrderID, FromDate, ToDate, StatusID } = this.state;
    this.setState({ isLoading: true });
    try {
      const data = await this.props.myOrders_list_action(
        OrderID,
        FromDate,
        ToDate,
        StatusID
      );

      console.log(data, "from UI MyOrders");
      if (data.error !== 1) {
        this.setState({
          MyOrdersData: data.data,
          proformaList: data.data,
          isLoading: false,
          currentpage: 1,
        });
      } else {
        if (
          data.msg == sessionExpireMessage ||
          data.msg == tokenInavlidMessage
        ) {
          //after session expire.....................
          sessionStorage.clear();
          this.props.navigate("/normalView");
          setTimeout(() => {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }, 500);
        } else {
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }

    localStorage.setItem("FromDate", FromDate);
    localStorage.setItem("ToDate", ToDate);
  };
  chooseDate(item) {
    this.setState({ dateRange: [item.selection] });
    this.setState({
      FromDate:
        item.selection["startDate"] != null ? (
          moment(item.selection["startDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
      ToDate:
        item.selection["endDate"] != null ? (
          moment(item.selection["endDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
    });
  }

  handleDelete(OrderID, DeliveryStatus) {
    const {
      userId,
      OrderNo,
      CancellationReasonID,
      cancelNote,
      AdminRemark,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount,
      ConvenienceFee,
      RefundAmount,
      BookingDate,
    } = this.state;
    this.setState({ isLoading: true });
    if (DeliveryStatus == "Incomplete") {
      var confirmDelete = window.confirm(
        "Are you sure you want to cancel this Order?"
      );
      if (confirmDelete) {
        this.props
          .order_delete_action(OrderID, OrderNo, CompanyName, PrimaryEmailID)
          .then((data) => {
            if (data.error !== 1) {
              toast.success(
                `The Order: ${OrderNo} has been Cancelled Successfully.`,
                {
                  theme: "colored",
                  position: "top-center",
                  autoClose: 4000,
                  hideProgressBar: true,
                }
              );
              this.myOrdersList();
            } else {
              if (
                data.msg == sessionExpireMessage ||
                data.msg == tokenInavlidMessage
              ) {
                //after session expire.....................
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }, 500);
              } else {
                toast.error(data.msg, {
                  theme: "colored",
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        window.location.reload();
      }
    } else {
      if (!CancellationReasonID) {
        toast.warning("Please select cancellation reason!", {
          theme: "colored",
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else if (!cancelNote) {
        toast.warning("Kindly Fill cancellation Note!", {
          theme: "colored",
          autoClose: 3000,
          position: "top-center",
          hideProgressBar: true,
        });
      } else if (!AdminRemark) {
        toast.warning("Kindly Fill Admin Remark!", {
          theme: "colored",
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        // First, execute order_cancel_reason_action
        this.props
          .order_cancel_reason_action(
            userId,
            OrderID,
            CancellationReasonID,
            cancelNote,
            AdminRemark,
            OrderNo,
            CompanyName,
            PrimaryEmailID,
            RoleID,
            OrderAmount,
            ConvenienceFee,
            RefundAmount
          )
          .then((data) => {
            if (data.error !== 1) {
              toast.success(`The order ${OrderNo} has been Deleted`, {
                theme: "colored",
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
              });
              this.deleteModalClose();
              window.location.reload();
            } else {
              if (
                data.msg == sessionExpireMessage ||
                data.msg == tokenInavlidMessage
              ) {
                //after session expire.....................
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }, 500);
              } else {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  }

  clearFilters = () => {
    window.location.reload(false);
  };
  downloadPerformaInvoice(ProformaInvoiceID, ProformaInvoice_No, ProformaType) {
    const { userId } = this.state;
    const formattedProformaInvoiceNo = ProformaInvoice_No.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });

    if (ProformaInvoiceID) {
      console.log(ProformaInvoiceID, formattedProformaInvoiceNo);
      const selectedProformaType = ProformaType === 'Slot Booking' ? 1 : ProformaType === "Additionalservices" ? 1 : 0
      this.props
        .download_performa_invoice_action(
          userId,
          ProformaInvoiceID,
          formattedProformaInvoiceNo, selectedProformaType
        )
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);

            // Open the report in a new tab
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored"
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot open: Proforma Invoice ID not found.", {
        position: "top-center", theme: "colored"
      });
    }
  }
  handleBlockedTill = (isRelease) => {
    const {
      userId,
      OrderID,
      BlockedDate,
      ItmeCenter,
      BookingDate,
      PrimaryEmailID,
    } = this.state;
    this.setState({ isLoading: true });

    // Determine the value of is_release based on the button clicked
    const is_release = isRelease ? true : false;
    // Determine the value of BlockedTill based on is_release
    const BlockedTill = is_release ? "" : BlockedDate;

    this.props
      .blocked_till_action(
        userId,
        OrderID,
        BlockedTill,
        is_release,
        ItmeCenter,
        BookingDate,
        PrimaryEmailID
      )
      .then((data) => {
        console.log(data, "insert");
        this.setState({ isLoading: false });

        if (data.error === 0) {
          const successMessage = OrderID
            ? "Data Updated Successfully"
            : "Data Inserted Successfully";
          console.log(successMessage);
          toast.success(successMessage, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          window.location.reload();
          this.modalClose();
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg || "An unknown error occurred.", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });

        toast.error("An unexpected error occurred.", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };
  updateItem(item) {
    console.log("updateItem : ", item);
    this.setState({ currentPage: item });
  }
  ordersRecord(MyOrdersData) {
    return (
      <table className="table table-bordered table-striped"
        id="dashboard-table">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th style={{ width: "7%" }}>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>ADDITIONAL SERVICE REQUEST</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>OUTSTANDINGS</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {MyOrdersData.length > 0 ? (
            MyOrdersData.map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>

                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {data.OrderAmount != null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>
                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus === "Pending for Verification"
                      ? "Pending for Action"
                      : data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  <span
                    className={
                      data.AdditionalServiceApprovalStatus === 0 &&
                        data.AdditionalServiceStatus === 1
                        ? "badge_soft_done"
                        : data.AdditionalServiceApprovalStatus === 1
                          ? "badge_soft_success"
                          : null
                    }
                  >
                    {data.AdditionalServiceApprovalStatus === 0 &&
                      data.AdditionalServiceStatus === 1
                      ? "Request for Additional Services"
                      : data.AdditionalServiceApprovalStatus === 1
                        ? "Approved"
                        : null}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {data.DeliveryStatus === "Confirmed" || data.DeliveryStatus === "Approved" ? (
                    data?.OutStanding?.toLocaleString("en-IN")
                  ) : (
                    <></>
                  )}
                </td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.isFeedbackRedirect(data.DeliveryStatus) ? (
                    <a
                      title="View Feedback"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() => this.onFeedbackNavigate(data.OrderID)}
                    >
                      <i className="fa fa-comments action_btn_table"></i>
                    </a>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    data.DeliveryStatus == "Incomplete" ? (
                      <a
                        title="Cancel Order"
                        className="btn btn-sm delete_record"
                        onClick={() =>
                          this.handleDelete(data.OrderID, data.DeliveryStatus)
                        }
                      >
                        <i className="fa fa-trash action_btn_table" />
                      </a>
                    ) : (
                      <a
                        title="Cancel Order"
                        className="btn btn-sm delete_record"
                        onClick={() =>
                          this.deleteModalShow(
                            data.OrderID,
                            data.OrderNo,
                            data.CompanyName,
                            data.PrimaryEmailID,
                            data.RoleID,
                            data.OrderAmount,
                            data.BookingDate,
                            data.CancellationReasonID,
                            data.cancelNote,
                            data.DeliveryStatus
                          )
                        }
                      >
                        <i className="fa fa-trash action_btn_table" />
                      </a>
                    )
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  incompleteRecord(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Incomplete").length > 0 ? (
            filterOrdersByStatus("Incomplete").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>
                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus === "Pending for Verification"
                      ? "Pending for Action"
                      : data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  confirmedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>OUTSTANDINGS</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Confirmed").length > 0 ? (
            filterOrdersByStatus("Confirmed").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {data?.OutStanding?.toLocaleString("en-IN")}
                </td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  reqAddServiceRecords(MyOrdersData) {
    const filterOrderByAdditionalService = (addServ) => {
      return MyOrdersData.filter((order) => {
        if (order.AdditionalServiceApprovalStatus === 0) {
          return order.AdditionalServiceStatus === addServ;
        }
        return false; // If the if condition doesn't match, return false
      });
    };

    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>OUTSTANDINGS</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrderByAdditionalService(1).length > 0 ? (
            filterOrderByAdditionalService(1).map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span className={"badge_soft_done"}>
                    {data.AdditionalServiceStatus === 1
                      ? "Request for Additional Services"
                      : null}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td></td>

                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  verificationRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Pending for Verification").length > 0 ? (
            filterOrdersByStatus("Pending for Verification").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus === "Pending for Verification"
                      ? "Pending for Action"
                      : data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  approvedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Approved").length > 0 ? (
            filterOrdersByStatus("Approved").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  rejectedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Rejected").length > 0 ? (
            filterOrdersByStatus("Rejected").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  requestRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Cancellation Request").length > 0 ? (
            filterOrdersByStatus("Cancellation Request").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  cancelRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Cancelled").length > 0 ? (
            filterOrdersByStatus("Cancelled").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  DeliveredRecords(MyOrdersData) {
    const { Is_view } = this.state;
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Delivered").length > 0 ? (
            filterOrdersByStatus("Delivered").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>

                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.isFeedbackRedirect(data.DeliveryStatus) ? (
                    <a
                      title="View Feedback"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() => this.onFeedbackNavigate(data.OrderID)}
                    >
                      <i className="fa fa-comments action_btn_table"></i>
                    </a>
                  ) : null}
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  closedRecords(MyOrdersData) {
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    return (
      <table className="table table-bordered table-striped">
        {/* Table header */}
        <thead>
          <tr>
            <th onClick={() => this.handleSort("OrderID")}>
              APPLICATION NO. <br />
              {this.state.sortedColumn === "OrderID" && (
                <i
                  className={`fa fa-sort-${this.state.sortOrder === "asc" ? "asc" : "desc"
                    }`}
                ></i>
              )}
            </th>
            <th>ORDER NUMBER</th>
            <th>ORDER DATE</th>
            <th>COMPANY NAME</th>
            <th>ITME CENTER</th>
            <th>BOOKING DATES</th>
            <th>TYPE OF EVENT</th>
            <th>ORDER AMOUNT</th>
            <th>FOLLOW UP</th>
            <th>ORDER STATUS</th>
            <th>PROFORMA INVOICE</th>
            <th>TAX INVOICE</th>
            <th>BLOCKED TILL</th>
            <th className="text-right" style={{ width: "9%" }}>
              ACTION
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody>
          {filterOrdersByStatus("Closed").length > 0 ? (
            filterOrdersByStatus("Closed").map((data) => (
              <tr key={data.OrderID}>
                {/* Render the rest of the table data for each row */}
                <td>{data.OrderID ? data.OrderID : "Not Available"}</td>
                <td>{data.OrderNo}</td>
                <td className="text-center">
                  {data.OrderDate
                    ? moment(data.OrderDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.ItmeCenter}</td>
                <td
                  style={{
                    overflowX: "hidden",
                    maxWidth: "4rem",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                  title={data.BookingDate}
                >
                  {data.BookingDate}
                </td>
                <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                <td className="text-right">
                  {" "}
                  {data.OrderAmount !== null
                    ? data.OrderAmount.toLocaleString("en-IN")
                    : null}{" "}
                </td>
                <td class="text-center">
                  {this.isFollowShow(data.DeliveryStatus) ? (
                    <div class="custom_dropdow">
                      <div class="dropdown">
                        <a class="dropbtn">
                          <i class="fa fa-address-card-o"></i>
                        </a>
                        <div class="dropdown-content followUp_Dropdown">
                          <div className="row">
                            <div className="col-10">
                              <span class="Status">
                                {data.Note ? data.Note : "No Status till now"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </td>
                <td className="text-center">
                  <span
                    className={
                      data.DeliveryStatus === "Incomplete"
                        ? "badge_soft_secondary"
                        : data.DeliveryStatus === "Confirmed"
                          ? "badge_soft_success"
                          : data.DeliveryStatus === "Cancelled"
                            ? "badge_soft_danger"
                            : data.DeliveryStatus === "Cancellation Request"
                              ? "badge_soft_warning"
                              : "badge_soft_done"
                    }
                  >
                    {data.DeliveryStatus}
                  </span>
                </td>
                <td className="text-center">
                  {this.isProformaShow(
                    data.StatusID,
                    data.Is_proforma,
                    data.DeliveryStatus
                  ) ? (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        this.generateProforma(data.OrderID, 0, 0);
                      }}
                    >
                      Generate
                    </button>
                  ) : data.ProformaInvoice_No?.length > 0 ? (
                    <a
                      title="Show Proforma"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.piModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.ProformaInvoiceID,
                          data.ProformaInvoice_No,
                          data.ProformaType
                        )
                      }
                    >
                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                    </a>
                  ) : null}
                </td>
                <td></td>
                <td className="text-center">
                  {this.isBlockTillShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Blocked Till"
                      onClick={() =>
                        this.modalShow(
                          data.BlockedDate,
                          data.OrderID,
                          data.BookingDate,
                          data.ItmeCenter,
                          data.PrimaryEmailID
                        )
                      }
                    >
                      <i className="fa fa-calendar action_btn_table"></i>
                      <br />
                      <span>
                        {data.BlockedDate
                          ? moment(data.BlockedDate).format("DD-MM-YYYY")
                          : null}
                      </span>
                    </a>
                  ) : null}
                </td>
                <td className="text-right">
                  <a
                    title="View Order"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.onPreviewNavigate(
                        data.OrderID,
                        data.OrderNo,
                        data.ClientID,
                        data.DeliveryStatus,
                        data.ProformaInvoiceID,
                        data.ProformaInvoice_No,
                        data.CompanyName,
                        data.PrimaryEmailID,
                        data.CenterID
                      )
                    }
                  >
                    <i class="fa fa-eye action_btn_table"></i>
                  </a>

                  {this.isEditShow(data.DeliveryStatus) ? (
                    <a
                      title="Edit Order"
                      className="btn btn-sm padding_0"
                      data-toggle="modal"
                      data-target="#editOrder"
                      onClick={() =>
                        this.editModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.StatusID,
                          data.CenterID,
                          data.BookingDate,
                          1,
                          data.ClientID
                        )
                      }
                    >
                      <i className="fa fa-edit action_btn_table"></i>
                    </a>
                  ) : null}
                  {this.isDeleteShow(data.DeliveryStatus) ? (
                    <a
                      title="Cancel Order"
                      className="btn btn-sm delete_record"
                      onClick={() =>
                        this.deleteModalShow(
                          data.OrderID,
                          data.OrderNo,
                          data.CompanyName,
                          data.PrimaryEmailID,
                          data.RoleID,
                          data.OrderAmount,
                          data.BookingDate,
                          data.CancellationReasonID,
                          data.cancelNote
                        )
                      }
                    >
                      <i className="fa fa-trash action_btn_table" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            // If MyOrdersData is empty, display a message or fallback content
            <tr>
              <td colSpan="15">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      PiShow,
      isAccordionExpanded,
      MyOrdersData,
      isEdit,
      OrderID,
      ClientID,
      StatusID,
      CenterID,
      BookingDate,
      editShow,
      OrderNo,
      ItmeCenter,
      EventName,
      eventFillList,
      CompanyName,
      startDate,
      endDate,
      FromDate,
      ToDate,
      deleteShow,
      CancellationReasonID,
      cancellationReasonList,
      cancelNote,
      AdminRemark,
      currentPage,
      OrderAmount,
      ConvenienceFee,
      RefundAmount,
      DeliveryStatus,
      deduction,
      finalAmount,
      show,
      BlockedDate,
      AdditionalServiceStatus,
      proformaList, isModifyEdit
    } = this.state;
    const filterOrdersByStatus = (status) => {
      return MyOrdersData.filter((order) => order.DeliveryStatus === status);
    };
    const filterOrderByAdditionalService = (addServ) => {
      return MyOrdersData.filter((order) => {
        if (order.AdditionalServiceApprovalStatus === 0) {
          return order.AdditionalServiceStatus === addServ;
        }
        return false; // If the if condition doesn't match, return false
      });
    };
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = MyOrdersData.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsIncomplete = filterOrdersByStatus("Incomplete").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsVerification = filterOrdersByStatus(
      "Pending for Verification"
    ).slice(indexOfFirstRecord, indexOfLastRecord);
    const currentRecordsApproved = filterOrdersByStatus("Approved").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsRejected = filterOrdersByStatus("Rejected").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsConfirmed = filterOrdersByStatus("Confirmed").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsReqAddService = filterOrderByAdditionalService(1).slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsRequest = filterOrdersByStatus(
      "Cancellation Request"
    ).slice(indexOfFirstRecord, indexOfLastRecord);

    const currentRecordsCancel = filterOrdersByStatus("Cancelled").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsDelivered = filterOrdersByStatus("Delivered").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const currentRecordsClosed = filterOrdersByStatus("Closed").slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

    const nPages = Math.ceil(MyOrdersData.length / recordsPerPage);
    const nPagesIncomplete = Math.ceil(
      filterOrdersByStatus("Incomplete").length / recordsPerPage
    );
    const nPagesVerification = Math.ceil(
      filterOrdersByStatus("Pending for Verification").length / recordsPerPage
    );
    const nPagesApproved = Math.ceil(
      filterOrdersByStatus("Approved").length / recordsPerPage
    );
    const nPagesRejected = Math.ceil(
      filterOrdersByStatus("Rejected").length / recordsPerPage
    );
    const nPagesConfirmed = Math.ceil(
      filterOrdersByStatus("Confirmed").length / recordsPerPage
    );
    const nPagesReqAddService = Math.ceil(
      filterOrderByAdditionalService(1).length / recordsPerPage
    );
    const nPagesRequest = Math.ceil(
      filterOrdersByStatus("Cancellation Request").length / recordsPerPage
    );
    const nPagesCancel = Math.ceil(
      filterOrdersByStatus("Cancelled").length / recordsPerPage
    );
    const nPagesDelivered = Math.ceil(
      filterOrdersByStatus("Delivered").length / recordsPerPage
    );
    const nPagesClosed = Math.ceil(
      filterOrdersByStatus("Closed").length / recordsPerPage
    );

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[18]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">Orders</h4>
                  {/* <div>
      <a href="#" class="btn btn-primary btn-sm create_btn" data-toggle="modal" data-target="#createRole">
          <i class="fa fa-plus"></i> <span class="hidden-xs">Add</span>
      </a>
    </div> */}
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Order Date :{" "}
                            <span>
                              {FromDate != "" && FromDate != "null" ? (
                                moment(FromDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}{" "}
                              &nbsp; - &nbsp;
                              {ToDate != "" && ToDate != "null" ? (
                                moment(ToDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}
                            </span>
                          </h5>
                          <h5>
                            OrderNo:
                            <span>{OrderNo}</span>
                          </h5>
                          <h5>
                            Company Name : <span>{CompanyName}</span>
                          </h5>
                          <h5>
                            Center Name : <span>{ItmeCenter}</span>
                          </h5>
                          <h5>
                            Type Of Event : <span>{EventName}</span>
                          </h5>
                          {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                          }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Order Date</label>
                                <DateRange
                                  editableDateInputs={true}
                                  onChange={(item) => this.chooseDate(item)}
                                  moveRangeOnFirstSelection={false}
                                  ranges={this.state.dateRange}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Order No</label>
                                <input
                                  value={OrderNo}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      OrderNo: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Center Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Company Name</label>
                                <input
                                  value={CompanyName}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      CompanyName: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Center Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Itme Center</label>
                                <input
                                  value={ItmeCenter}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      ItmeCenter: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  id="search"
                                  placeholder="Search for Center Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Type Of Event</label>
                                <select
                                  className="form-control"
                                  value={EventName}
                                  onChange={(e) =>
                                    this.setState({
                                      EventName: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">Select</option>
                                  {eventFillList.length > 0
                                    ? eventFillList.map((data) => (
                                      <option
                                        key={data.TypeOfEventID}
                                        value={data.TypeOfEventID} // Store the TypeOfEventID
                                      >
                                        {data.EventName}
                                      </option>
                                    ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.myOrdersList()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-sliders" />
                                Filters
                              </button>
                              &nbsp;
                              <button
                                onClick={() => this.clearFilters()}
                                className="btn btn-primary search_btn"
                              >
                                <i className="fa fa-times" />
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row mr_0">
                    <div className="col-md-12 padding_0">
                      <Tab.Container defaultActiveKey="all">
                        <Nav
                          variant="tabs"
                          className="nav nav-tabs nav-tabs-custom nav-success mb-3"
                          role="tablist"
                        >
                          <Nav.Item>
                            <Nav.Link
                              eventKey="all"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-store-2-fill me-1 align-bottom" />{" "}
                              All Orders
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Incomplete"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-arrow-left-right-fill me-1 align-bottom" />{" "}
                              InComplete
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Pending for Verification"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-qr-scan-2-line me-1 align-bottom" />{" "}
                              Pending for Action
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Approved"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-fill me-1 align-bottom" />{" "}
                              Approved
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Rejected"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-close-line me-1 align-bottom" />{" "}
                              Rejected
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Confirmed"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-double-line me-1 align-bottom" />{" "}
                              Confirmed
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Request for Additional Services"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-error-warning-line me-1 align-bottom" />{" "}
                              Request for Additional Services
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Cancellation Request"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-error-warning-line me-1 align-bottom" />{" "}
                              Cancellation Request
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="cancelled"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-close-circle-line me-1 align-bottom" />{" "}
                              Cancelled
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Delivered"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-checkbox-circle-line me-1 align-bottom" />{" "}
                              Delivered
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              eventKey="Closed"
                              onClick={() => this.setState({ currentPage: 1 })}
                            >
                              <i className="ri-check-double-line me-1 align-bottom" />{" "}
                              Closed
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content>
                          {/* All Orders Tab */}
                          <Tab.Pane eventKey="all">
                            {this.ordersRecord(currentRecords)}
                            {MyOrdersData.length > 0 ? (
                              <Pagination
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                            <Modal
                              show={PiShow}
                              // onHide={this.piModalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Proforma Invoice for Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.piModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <h5>Proforma Invoice List</h5>
                                  <table className="table table-striped table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">
                                          Proforma Invoice No.
                                        </th>
                                        <th scope="col">
                                          Proforma Invoice Type
                                        </th>
                                        <th scope="col">Download</th>
                                      </tr>
                                    </thead>
                                    <tbody id="show_proformainvoices">
                                      {proformaList.length > 0 ? (
                                        proformaList.map((data, i) => (
                                          <tr key={data.ProformaInvoiceID}>
                                            <td colSpan="">{i + 1}</td>
                                            <td>{data.ProformaInvoice_No}</td>
                                            <td>
                                              {data.ProformaType === "Additionalservices" ? "Rental & Additional Services" : data.ProformaType ===
                                                ("Slot Booking") ? "Rental" : "Additional Amount"}
                                            </td>
                                            <td>
                                              <a
                                                title="Download Proforma"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  this.downloadPerformaInvoice(
                                                    data.ProformaInvoiceID,
                                                    data.ProformaInvoice_No, data.ProformaType
                                                  )
                                                }
                                              >
                                                <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                              </a>
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="4">
                                            No Proforma Details Found!
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.piModalClose()}
                                >
                                  Close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={editShow}
                              // onHide={this.editModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Modify Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.editModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <ol>
                                    <h5>Order Modification</h5>
                                    <hr />
                                    <li>
                                      Any postponement date is allowed only once
                                      after that you cannot change the date
                                    </li>
                                    <li>
                                      After the postponement/change of the date
                                      of the booking, you cannot cancel the
                                      booking.
                                    </li>
                                    <li>
                                      If you cancel the booking after the change
                                      of the date, your total amount will be
                                      forfeited.
                                    </li>
                                    <li>
                                      The change of booking date will be allowed
                                      only on the availability of the venue and
                                      on a first come first serve basis
                                    </li>
                                  </ol>
                                </div>
                                <Button
                                  variant="success"
                                  onClick={() => this.AgreeModification(OrderID,
                                    OrderNo,
                                    StatusID,
                                    CenterID,
                                    BookingDate,
                                    isEdit,
                                    ClientID, 0)}
                                >
                                  Agree
                                </Button>

                                <hr />
                                {isModifyEdit ? (
                                  <table className="table table-bordered table-striped">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Navigate to</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>1</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 1
                                          )
                                        } >Calendar View</td>
                                      </tr>
                                      <tr>
                                        <td>2</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 2
                                          )
                                        } >Organiser's Info</td>
                                      </tr>
                                      <tr>
                                        <td>3</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 3
                                          )
                                        } >Booking Details</td>
                                      </tr>
                                      <tr>
                                        <td>4</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 4
                                          )
                                        } >Additional Services</td>
                                      </tr>
                                      <tr>
                                        <td>5</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 5
                                          )
                                        } >Terms & conditions</td>
                                      </tr>
                                      <tr>
                                        <td>6</td>
                                        <td style={{ cursor: "pointer" }} onClick={() =>
                                          this.onEditNavigate(
                                            OrderID,
                                            OrderNo,
                                            StatusID,
                                            CenterID,
                                            BookingDate,
                                            isEdit,
                                            ClientID, 6
                                          )
                                        } >Summary</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ) : null}
                              </Modal.Body>

                            </Modal>
                            <Modal
                              show={show}
                              // onHide={this.modalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>Blocked Till</Modal.Title>
                                <span
                                  onClick={this.modalClose}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <label>Date</label>
                                <DatePicker
                                  className="form-control"
                                  dateFormat="dd/MM/yyyy"
                                  selected={BlockedDate}
                                  onChange={(date) => {
                                    this.setState({ BlockedDate: date });
                                  }}
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  placeholderText="Date"
                                />
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.handleBlockedTill(false)} // "SUBMIT" button
                                >
                                  SUBMIT
                                </Button>
                                <Button
                                  variant="secondary"
                                  onClick={() => this.handleBlockedTill(true)} // "UNBLOCK" button
                                >
                                  UNBLOCK
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            {/* deleteModal */}
                            <Modal
                              show={deleteShow}
                              // onHide={this.deleteModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Cancel Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.deleteModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <h5>CANCELLATION & REFUND</h5>
                                  <hr />
                                  <ul>
                                    <li>
                                      Once the ITME Center receives the online
                                      application forms for booking,
                                      cancellation of participation or reduction
                                      in requirements/packages will not be
                                      allowed after confirmation.
                                    </li>
                                    <li>
                                      If on any terms the event if canceled by
                                      the client then the cancellation charges
                                      will be as follows:
                                      <ol>
                                        <li>
                                          <strong>
                                            Event Cancelled 15 days prior – 25 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 10 days prior –75 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 5 days prior – 100 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                      </ol>
                                    </li>
                                    <li>
                                      The date on which written communication
                                      conveying full or partial cancellation is
                                      received by the Authority will be
                                      considered as the effective date for
                                      determining the cancellation charges.
                                    </li>
                                    <li>
                                      The advance amount / refundable amount and
                                      security deposit (if any) will be paid
                                      after deducting applicable taxes, banking
                                      charges, and administrative charges.
                                    </li>
                                  </ul>
                                </div>
                                <div class="form-group">
                                  <table
                                    className="table table-bordered"
                                    style={{ maxWidth: "25rem" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <th>Order Amount</th>
                                        <td>
                                          {" "}
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={OrderAmount}
                                            onChange={(e) =>
                                              this.setState({
                                                OrderAmount: e.target.value,
                                              })
                                            }
                                            disabled
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Service Charges</th>
                                        <td>
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={ConvenienceFee.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>
                                              this.setState({
                                                ConvenienceFee: e.target.value,
                                              })
                                            }
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Total Refundable</th>
                                        <td>
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={RefundAmount.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>
                                              this.setState({
                                                RefundAmount: e.target.value,
                                              })
                                            }
                                            disabled
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="form-group">
                                  <label>Reason</label>
                                  <select
                                    id="country"
                                    name="Reason"
                                    value={CancellationReasonID}
                                    onChange={(e) => {
                                      const selectedReasonId = e.target.value;
                                      this.setState({
                                        CancellationReasonID: selectedReasonId,
                                      });
                                    }}
                                    className="form-control floating-control"
                                  >
                                    <option value="">SELECT REASON</option>
                                    {cancellationReasonList.length > 0 &&
                                      cancellationReasonList.map((data) => (
                                        <option
                                          key={data.CancellationReasonID}
                                          value={data.CancellationReasonID}
                                        >
                                          {data.Name}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Cancellation Note</label>
                                  <textarea
                                    value={cancelNote ? cancelNote : ""}
                                    onChange={(e) =>
                                      this.setState({
                                        cancelNote: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Internal Remark</label>
                                  <textarea
                                    value={AdminRemark}
                                    onChange={(e) =>
                                      this.setState({
                                        AdminRemark: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="danger"
                                  onClick={() =>
                                    this.handleDelete(OrderID, DeliveryStatus)
                                  } // "SUBMIT" button
                                >
                                  Approve
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Tab.Pane>

                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Incomplete">
                            {this.incompleteRecord(currentRecordsIncomplete)}
                            {filterOrdersByStatus("Incomplete").length > 0 ? (
                              <Pagination
                                nPages={nPagesIncomplete}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Pending for Verification Tab */}
                          <Tab.Pane eventKey="Pending for Verification">
                            {this.verificationRecords(
                              currentRecordsVerification
                            )}
                            {filterOrdersByStatus("Pending for Verification")
                              .length > 0 ? (
                              <Pagination
                                nPages={nPagesVerification}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Approved">
                            {this.approvedRecords(currentRecordsApproved)}
                            {filterOrdersByStatus("Approved").length > 0 ? (
                              <Pagination
                                nPages={nPagesApproved}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Rejected">
                            {this.rejectedRecords(currentRecordsRejected)}
                            {filterOrdersByStatus("Rejected").length > 0 ? (
                              <Pagination
                                nPages={nPagesRejected}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Confirmed">
                            {this.confirmedRecords(currentRecordsConfirmed)}
                            {filterOrdersByStatus("Confirmed").length > 0 ? (
                              <Pagination
                                nPages={nPagesConfirmed}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* In Progress Tab */}
                          <Tab.Pane eventKey="Request for Additional Services">
                            {this.reqAddServiceRecords(
                              currentRecordsReqAddService
                            )}
                            {filterOrderByAdditionalService(1).length > 0 ? (
                              <Pagination
                                nPages={nPagesReqAddService}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>

                          {/* Cancellation Request Tab */}
                          <Tab.Pane eventKey="Cancellation Request">
                            {this.requestRecords(currentRecordsRequest)}
                            {filterOrdersByStatus("Cancellation Request")
                              .length > 0 ? (
                              <Pagination
                                nPages={nPagesRequest}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Cancelled Tab */}
                          <Tab.Pane eventKey="cancelled">
                            {this.cancelRecords(currentRecordsCancel)}
                            {filterOrdersByStatus("Cancelled").length > 0 ? (
                              <Pagination
                                nPages={nPagesCancel}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          {/* Delivered Tab */}

                          <Tab.Pane eventKey="Delivered">
                            {this.DeliveredRecords(currentRecordsDelivered)}
                            {filterOrdersByStatus("Delivered").length > 0 ? (
                              <Pagination
                                nPages={nPagesDelivered}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                          <Tab.Pane eventKey="Closed">
                            {this.closedRecords(currentRecordsClosed)}
                            {filterOrdersByStatus("Closed").length > 0 ? (
                              <Pagination
                                nPages={nPagesClosed}
                                currentPage={currentPage}
                                setCurrentPage={this.updateItem}
                              />
                            ) : (
                              <></>
                            )}
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <style type="text/css">{followUpStyle}</style>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    myOrders_list_action,
    order_delete_action,
    fill_action,
    blocked_till_action,
    download_performa_invoice_action,
    get_follow_up_action,
    order_cancel_reason_action,
  })(Orders)
);
